import { css } from '@emotion/css';
import { DesignToken } from '@livechat/design-system-react-components';

interface IStyledIconProps {
  width?: string;
  height?: string;
  inline?: boolean;
}

export const iconWrapper = ({ width, height, inline }: IStyledIconProps): string => css`
  display: ${inline ? 'inline-flex' : 'block'};
  align-items: center;
  width: ${width || '16px'};
  height: ${height || '16px'};
  line-height: ${height || '16px'};
`;

export const placeholderStyles = ({ width = '12px', height = '12px', inline = false }): string => css`
  background-color: var(${DesignToken.Background01});
  opacity: 0.1;
  width: ${width};
  height: ${height};
  border-radius: 4px;
  ${inline ? 'display: block' : 'display: inline-block'};
`;
